import { render, staticRenderFns } from "./NewAMForgotUsernameUserDetailsComponent.vue?vue&type=template&id=59257e6b&scoped=true"
import script from "./NewAMForgotUsernameUserDetailsComponent.vue?vue&type=script&lang=js"
export * from "./NewAMForgotUsernameUserDetailsComponent.vue?vue&type=script&lang=js"
import style0 from "./NewAMForgotUsernameUserDetailsComponent.vue?vue&type=style&index=0&id=59257e6b&prod&lang=css"
import style1 from "./NewAMForgotUsernameUserDetailsComponent.vue?vue&type=style&index=1&id=59257e6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59257e6b",
  null
  
)

export default component.exports